export const Action_SetCurrentSection = 'SET_CURRENT_SECTION';
export const Action_SetCurrentApplication = 'SET_CURRENT_APPLICATION';
export const Action_StudentValidationForNewApplication = 'STUDENT_VALIDATION_NEW_APPLICATION';
export const Action_StoreStudentDetails = 'STORE_STUDENT_DETAILS';
export const Action_ClearStudentDetails = 'CLEAR_STUDENT_DETAILS';
export const Action_ApplicationSectionSaved = 'APPLICATION_SECTION_SAVED';
export const Action_ApplicationProgramChanged = 'APPLICATION_PROGRAM_SAVED';
